/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Share_Code_LabelInputs */

const en_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Share Code`)
};

const fr_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code de partage du projet`)
};

const de_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt-Freigabecode`)
};

const it_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice di condivisione del progetto`)
};

const ru_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Код доступа к проекту`)
};

const es_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código para compartir del proyecto`)
};

const zh_cn2_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目共享代码`)
};

const ja_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト共有コード`)
};

const hi_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट शेयर कोड`)
};

const pt_pt2_team_project_import_share_code_label = /** @type {(inputs: Team_Project_Import_Share_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de compartilhamento do projeto`)
};

/**
* | output |
* | --- |
* | "Project Share Code" |
*
* @param {Team_Project_Import_Share_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_share_code_label = /** @type {((inputs?: Team_Project_Import_Share_Code_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Share_Code_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_share_code_label(inputs)
	if (locale === "de") return de_team_project_import_share_code_label(inputs)
	if (locale === "it") return it_team_project_import_share_code_label(inputs)
	if (locale === "ru") return ru_team_project_import_share_code_label(inputs)
	if (locale === "es") return es_team_project_import_share_code_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_share_code_label(inputs)
	if (locale === "ja") return ja_team_project_import_share_code_label(inputs)
	if (locale === "hi") return hi_team_project_import_share_code_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_share_code_label(inputs)
	return en_team_project_import_share_code_label(inputs)
});